export const englishTech = {
  templateId: 'tech',
  language: 'en',
  name: 'Tech & Electronics (English)',
  description: 'Technology and electronics shopping list',
  icon: '📱',
  categories: [
    {
      name: 'Mobile & Accessories',
      items: [
        'Phone case',
        'Screen protector',
        'Phone charger',
        'Wireless charger',
        'Power bank',
        'Bluetooth headphones',
        'Car mount',
        'Pop socket',
        'Memory card',
        'USB cable',
        'Lightning cable',
        'Airpods',
        'Phone stand',
        'Selfie stick',
        'Camera lens kit'
      ]
    },
    {
      name: 'Computer & Gaming',
      items: [
        'Laptop',
        'Mouse',
        'Keyboard',
        'Monitor',
        'Webcam',
        'USB hub',
        'External hard drive',
        'Gaming headset',
        'Controller',
        'Graphics card',
        'RAM',
        'SSD',
        'Motherboard',
        'CPU',
        'Cooling fan'
      ]
    },
    {
      name: 'Smart Home',
      items: [
        'Smart bulbs',
        'Smart switch',
        'Smart speaker',
        'Security camera',
        'Smart doorbell',
        'Smart thermostat',
        'Smart plug',
        'Robot vacuum',
        'Smart lock',
        'Motion sensor',
        'Smart TV',
        'Streaming device',
        'WiFi router',
        'Range extender',
        'Smart display'
      ]
    },
    {
      name: 'Audio & Video',
      items: [
        'Bluetooth speaker',
        'Soundbar',
        'Subwoofer',
        'Microphone',
        'Record player',
        'Vinyl records',
        'HDMI cable',
        'Audio cable',
        'Studio monitors',
        'DJ mixer',
        'Amplifier',
        'Streaming camera',
        'Tripod',
        'Ring light',
        'Green screen'
      ]
    },
    {
      name: 'Wearables',
      items: [
        'Smartwatch',
        'Fitness tracker',
        'VR headset',
        'Smart glasses',
        'Heart rate monitor',
        'Smart ring',
        'Activity tracker',
        'Sleep tracker',
        'GPS watch',
        'Smart earbuds'
      ]
    }
  ]
};
